module.exports = "//static.hsappstatic.net/ContentComponents/static-2.70518/img/payment_methods.png"